<template>
  <div class="culture-box">
    <div class="carousel-class">
      <img src="../../assets/img/story.jpg" alt  style="width:100%;"/>
    </div>
    <div class="text-box" style="margin-top: -450px; ">
      <div class="border-box">
        <img src="../../assets/img/2.jpg" alt />
        <!-- <i class="el-icon-back iconCss" @click="$router.push('/homePage')"></i> -->
        <div class="describe-txt">
          <p>
            <!-- style="font-family: '黑体'; font-size: 18px; font-weight:600;"  -->
            &nbsp;&nbsp;&nbsp;&nbsp;深圳市慧智创新网络有限公司成立于2023年12月22日，注册地位于深圳市宝安区西乡街道河西社区八十一区前进二路93号586。经营范围包括一般经营项目是：计算机软硬件开发等。
            慧智创新通过对接 eBay、亚马逊、Shopee、Lazada、Wish等平台，为中国的优秀跨境卖家服务，帮助卖家们解决和优化订单、供应链，广告投放的等问题。
            慧智创新组织架构完整，分工明确，我们拥有出类拔萃的IT团队、运营团队。
            在慧智创新书堂，我们有完整的全员培训课程，也有严谨的晋升体系，我们有温度；
            在IT中心，我们有精英有团队，有平日里的运营维护，我们有科技；在仓储物
            流领域建立了一套从采购、物流、仓储及海外设仓的完整模
            块，实现了资源有效整合。
            云淡风轻，一展宏图，慧智创新是一家欣欣向荣的年轻企业，核心成员均为年轻的创业者。目前
            公司规模30多人。70%的90后年轻人是慧智创新的核心战力，是一个有朝气、目标明确，追
            求高效执行力的高知团队，成长空间和发展潜力巨大。如果您渴望在跨境电商行业
            中找到高效、安全、智能的ERP系统，慧智创新帮您实现。
          </p>
        </div>
      </div>
    </div>
    <img src="../../assets/img/history.jpg" alt />
    <div class="company-branch">
      <div class="common-tip banner">
        <!---->
        <div class="banner-text">
          <div class="banner-title">
            <img src="../../assets/img/me.png" alt />
          </div>
          <ul class="address">

            <li>
              地址：广东省深圳市宝安区西乡街道河西社区八十一区前进二路93号586
            </li>
            <li>邮箱：huizhichuangxinkj@163.com</li>
            <li>电话：0755-28913594</li>
            <li>邮编：518000</li>
          </ul>

        </div>
      </div>
      <div class="branch-content">
        <div style="width:900px;height:636px;border:#ccc solid 1px;font-size:12px;margin:0 auto;" id="map"></div>
      </div>
    </div>

    <mainBottom></mainBottom>
  </div>
</template>
<script>
import mainBottom from "@/components/container/bottom";
export default {
  components: { mainBottom },
  mounted() {
    let map = new BMap.Map("map");
    map.centerAndZoom(new BMap.Point(113.883499, 22.580429), 19);
    map.enableScrollWheelZoom();
    map.enableKeyboard();
    map.enableDragging();
    map.enableDoubleClickZoom();
    var markers = [
      {
        content: "地址：广东省深圳市宝安区西乡街道河西社区八十一区前进二路93号586",
        title: "深圳市慧智创新网络有限公司",
        imageOffset: { width: 0, height: 3 },
        position: { lat: 22.580429, lng: 113.883499 },
      },
    ];
    for (var index = 0; index < markers.length; index++) {
      var point = new BMap.Point(
        markers[index].position.lng,
        markers[index].position.lat
      );
      var marker = new BMap.Marker(point, {
        icon: new BMap.Icon(
          "https://api.map.baidu.com/lbsapi/createmap/images/icon.png",
          new BMap.Size(20, 25),
          {
            imageOffset: new BMap.Size(
              markers[index].imageOffset.width,
              markers[index].imageOffset.height
            ),
          }
        ),
      });
      var label = new BMap.Label(markers[index].title, {
        offset: new BMap.Size(25, 5),
      });
      var opts = {
        width: 200,
        title: markers[index].title,
        enableMessage: false,
      };
      var infoWindow = new BMap.InfoWindow(markers[index].content, opts);
      marker.setLabel(label);
      map.addOverlay(marker);
      marker.addEventListener("click", function () {
        marker.openInfoWindow(infoWindow);
      });

      var scaleControl = new BMap.ScaleControl({
        anchor: BMAP_ANCHOR_BOTTOM_LEFT,
      });
      scaleControl.setUnit(BMAP_UNIT_IMPERIAL);
      map.addControl(scaleControl);
      var navControl = new BMap.NavigationControl({
        anchor: BMAP_ANCHOR_TOP_LEFT,
        type: BMAP_NAVIGATION_CONTROL_LARGE,
      });
      map.addControl(navControl);
      var overviewControl = new BMap.OverviewMapControl({
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        isOpen: true,
      });
      map.addControl(overviewControl);
    }
  },
};
</script>
<style scoped>
.banner-box {
  width: 100%;
  height: 607px;
  background: url("../../assets/images/about.jpg") no-repeat 50%;
  background-size: cover;
}

.history-content {
  padding-bottom: 124px;
  margin: 0 auto;
  width: 1396px;
}

.history-content .content-bg {
  background: url("../../assets/images/2e73ed7.png") no-repeat 50%;
  height: 410px;
  position: relative;
}

.history-content .content-bg .history-tip {
  position: absolute;
}

.tip-1 {
  top: 83%;
  left: -5%;
}

.tip-1 p {
  width: 100px;
}

.tip-2 {
  top: 80%;
  left: 10%;
}

.tip-2 p {
  width: 100px;
}

.tip-3 {
  top: 52.5%;
  left: 23%;
}

.tip-3 p {
  width: 120px;
}

.tip-4 {
  top: 28%;
  left: 37%;
}

.tip-4 p {
  width: 100px;
}

.tip-5 {
  top: 54%;
  left: 51.5%;
}

.tip-5 p {
  width: 100px;
  margin-left: 100px;
  margin-top: -60px;
}

.tip-6 {
  top: 76%;
  left: 62%;
}

.tip-6 p {
  width: 100px;
}

.tip-7 {
  top: 58%;
  left: 73%;
}

.tip-7 p {
  width: 100px;
}

.tip-8 {
  top: 25%;
  left: 85%;
}

.tip-8 p {
  width: 100px;
}

.history-tip span {
  display: inline-block;
  background-color: #339afe;
  color: #fff;
  border-radius: 50%;
  margin-top: 5px;
  width: 90px;
  height: 90px;
  text-align: center;
  line-height: 90px;
}

.company-branch {
  background-color: #f0f9fe;
  padding: 8px 0 88px;
}

.company-branch .branch-content {
  height: 650px;
  background: url("../../assets/images/6cd534d.png") no-repeat 50%;
}

.company-branch .branch-content .branch-map {
  width: 793px;
  height: 658px;
  margin: 0 auto;
  position: relative;
}

.company-branch .branch-content .branch-map .city-1 {
  top: 412px;
  left: 385px;
  width: 100px;
  height: 25px;
  display: inline-block;
  position: absolute;
  font-size: 13px;
  z-index: 100;
  cursor: pointer;
}

.company-branch .branch-content .branch-map .city-2 {
  top: 416px;
  left: 508px;
  width: 100px;
  height: 25px;
  display: inline-block;
  position: absolute;
  font-size: 13px;
  z-index: 100;
  cursor: pointer;
}

.company-branch .branch-content .branch-map .city-3 {
  top: 526px;
  left: 532px;
  width: 100px;
  height: 25px;
  display: inline-block;
  position: absolute;
  font-size: 13px;
  z-index: 100;
  cursor: pointer;
}

.company-branch .branch-content .branch-map .city-4 {
  top: 550px;
  left: 555px;
  width: 100px;
  height: 25px;
  display: inline-block;
  position: absolute;
  font-size: 13px;
  z-index: 100;
  cursor: pointer;
}

.company-branch .branch-content .branch-map .city-3 {
  top: 415px;
  left: 630px;
  width: 100px;
  height: 25px;
  display: inline-block;
  position: absolute;
  font-size: 13px;
  z-index: 100;
  cursor: pointer;
}

.border-box {
  border: 1px solid #f8f8f8;
  position: relative;
}

.describe-txt {
  position: absolute;
  width: 600px;
  left: 200px;
  top: 200px;
}

.iconCss {
  position: absolute;
  left: 20px;
  top: 20px;
  font-size: 30px;
  font-weight: bold;
  width: 100px;
  color: #0d49a9;
  cursor: pointer;
}

.address {
  list-style: square;
  width: 900px;
  margin: 0px auto;
  padding-left: 25px;
}

.address li::marker {
  color: #0d49a9;
}

.address li {
  text-align: left;
  color: #2c3e50;
  font-size: 16px;
}
</style>
